// @flow
import React, { type Node } from 'react';
import { Box } from 'gestalt';
import { MODAL_ZINDEX } from 'app/common/react/ui/Modal';

const ARROW_SIZE_PIXELS = 24;

type Props = {|
  anchor: ?HTMLElement,
  children: Node,
  isHorizontalDesign?: boolean,
|};

export default function AvatarHoverCardFlyout({ anchor, children, isHorizontalDesign }: Props) {
  if (!anchor) {
    return null;
  }

  const flyoutSizePixels = isHorizontalDesign ? 320 : 236;
  const { left, top, width, height } = anchor.getBoundingClientRect();
  const xOffset = left + window.pageXOffset;
  const yOffset = top + window.pageYOffset;
  const isLeft = xOffset + width + flyoutSizePixels + ARROW_SIZE_PIXELS / 2 > window.innerWidth;
  const wrapperStyle = {
    left: isLeft ? xOffset : xOffset + width,
    top: yOffset + height / 2,
    zIndex: MODAL_ZINDEX,
  };
  const containerStyle = {
    borderRadius: 21,
    boxShadow: '0 9px 26px rgba(0, 0, 0, 0.4)',
    left: isLeft ? -ARROW_SIZE_PIXELS / 2 - flyoutSizePixels : ARROW_SIZE_PIXELS / 2,
    top: -flyoutSizePixels / 2 - 44,
  };
  const arrowStyle = {
    top: -ARROW_SIZE_PIXELS / 2,
    left: -ARROW_SIZE_PIXELS / 2,
    fill: 'white',
  };
  const arrowPath = isLeft ? 'M0 0 L12 12 L0 24' : 'M24 0 L12 12 L24 24';

  return (
    <Box position="absolute" dangerouslySetInlineStyle={{ __style: wrapperStyle }}>
      <Box
        position="absolute"
        color="white"
        dangerouslySetInlineStyle={{ __style: containerStyle }}
        width={flyoutSizePixels}
        overflow="hidden"
      >
        {children}
      </Box>
      <Box position="absolute" dangerouslySetInlineStyle={{ __style: arrowStyle }}>
        <svg width={ARROW_SIZE_PIXELS} height={ARROW_SIZE_PIXELS}>
          <path d={arrowPath} />
        </svg>
      </Box>
    </Box>
  );
}
